<template>
  <div>
    <div :id="warningPopupId" class="modal custom" role="dialog">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header no-border">
            <div class="modal-header-wrapper">
              <p class="cancel-subscription" v-if="warningPopupId === 'cancelSubscription'">{{$t('cancelSubscription')}}</p>
              <p class="cancel-subscription" v-else>{{$t('editRole')}}</p>
              <div class="close-btn p-0">
                <img @click="closePopup" class="cursor-pointer" src="/static/images/icons/ul_close_icon.svg" />
              </div>
            </div>
          </div>
          <div class="modal-body p-0 row m-0">
            <div class="col-xs-12 p-0">
            <p class="confirm_title">{{ warningBody }}</p>
            <p class="delete-warn" v-if="customMessage">{{ customMessage }}</p>
            <p class="delete-warn" v-if="products && products.length !==0 ">{{ productMessage }}</p>
            <p class="confirm-delete">{{ confirmMessage }}</p>
            </div>
          </div>
          <div class="modal-footer flex-column" v-if="warningPopupId === 'cancelSubscription'">
            <button type="button" class="blue_outline_cancel_button xs-mb-10" @click="closePopup()" style="max-width:245px;">
          {{ $t('noDontCancel')}}
            </button>
            <button
              type="button"
              class="blue_filled_Proceed_button"
              @click="confirmCancel()"
            >{{ $t('yesCancel') }}</button>
          </div>
          <div class="modal-footer flex-column" v-else>
            <button type="button" class="blue_outline_cancel_button xs-mb-10" @click="cancelChanges">
          {{ $t('cancel')}}
            </button>
            <button
              type="button"
              class="blue_filled_Proceed_button"
              @click="closePopup()"
            >OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    warningPopupId: {
      type: String,
      required: false,
    },
    warningBody: {
      type: String,
      required: false,
    },
    confirmMessage: {
      type: String,
      required: false,
    },
    customMessage: {
      type: String,
      required: false,
    },
    products: {
      type: Array,
      required: false,
    },
    productMessage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    /* dashboardPublishDelete()
     * to delete the document based on the id
     */
    cancelChanges() {
      $(`#${this.warningPopupId}`).modal('hide');
      this.$emit('closeEdit');
    },
    closePopup() {
      $(`#${this.warningPopupId}`).modal('hide');
    },
    confirmCancel() {
      $(`#${this.warningPopupId}`).modal('hide');
      this.$emit('confirmCancel');
    },
  },
};
</script>

<style scoped>
.delete-team-member {
  color: #333333;
}
.modal-header-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 17px 20px 17px 16px;
}
.cancel-subscription {
  font-weight: 600;
  color: #1A1A1A;
  font-size: 20px;
}
.custom .modal-content{
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
}
.custom .modal-header{
    padding: 0px !important;
    background-color: #fff !important;
    /* border-bottom: none; */
}
.custom .modal-header .close-btn{
  position: relative;
}
.custom .modal-body{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 5px;
}
.custom .modal-body .confirm_title{
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.custom .modal-body .delete-warn{
  /* margin-bottom: 24px; */
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  line-height: 27px;
}
.custom .modal-body .confirm-delete{
  margin-bottom: 34px;
  margin-top: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}
.blue_outline_cancel_button{
  background-color: #E6E6E6;
  border: none;
  height: 44px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 18px;
  color: #404040;
  padding: 10px 16px;
}
.blue_filled_Proceed_button{
  background-color: #01518A;
    height: 44px;
    border: none;
    cursor: pointer;
    border-radius: 3px;
    margin-top: 0px !important;
    font-weight: 600;
    font-size: 18px;
    color:#ffffff;
    padding: 10px 16px;
}
.w-210 {
  max-width:210px
}
.mb-20 {
  margin-bottom: 20px;
}

p {
  margin-bottom: 0px;
}
.mr-16{
  margin-right: 16px;
}
.modal-footer .btn {
  width: 160px;
}

.mb-40{
  margin-bottom: 40px;
}

/* .cancel-span{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
} */

.delete {
  background: #4C9E45;
  border: 1px solid #4C9E45;
  box-sizing: border-box;
  border-radius: 20px;
  height: 36px;
  width: 160px;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
}

.delete-span{
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #F2F2F2;
}

.custom .modal-header {
  padding-left: 30px;
  /* border-bottom: 0 none; */
  background-color : white;
  padding-right: 10px;
  padding-bottom: 0;
}

.modal-body {
  font-weight: 500;
  padding: 16px 10px 20px 20px;
}

.doc_name {
  font-size: 14px;
  font-weight: 400;
}

.custom .modal-footer{
  border-top: 0 none;
  background-color : #FAFAF9;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  column-gap: 16px;
  padding-right: 0px;
}

.confirm_title{
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  word-break: break-word;
}

.modal-content{
  border-radius: 10px !important;
}

.modal-dialog{
  width: 500px;
  max-width: 600px;
}

.text-start {
  text-align: start;
}

.mb-30 {
  margin-bottom: 30px;
}

ul {
  max-height: 150px;
  overflow: auto;
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px black;
  background-color: white;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: gray;
}

@media screen and (max-width: 767px) {
  .xs-mb-10 {
    margin-bottom: 10px;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 768px){
  .modal-footer .cancel{
    margin-right: 16px;
  }
}
</style>
